import {
  Grid,
  GridColumn,
  GridPageChangeEvent,
  GridRowClickEvent,
} from "@progress/kendo-react-grid";
import { PageState } from "@mikros/library";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import React, {useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Button} from "@progress/kendo-react-buttons";
import { useNavigate } from "react-router-dom";
import ApiServices from "../../service/apiService";
import ErrorHandler from "../../utils/errorConfig";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "@mikros/shared-ui";


export function AdminList() {
  const navigate = useNavigate();
  const intl = useIntl()
  const errorInstance = ErrorHandler.getErrorInstance();
 
  
  const initialDataState: PageState = { pageNumber: 1, skip: 0, take: 10 };

  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();
  const [dataGrid, setDataGrid] = useState([]);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    //@ts-ignore
    const take =
      targetEvent.value === "All" ? dataGrid.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    
    setPage((prevPage) => ({
      ...prevPage,
      ...event.page,
      take,
    }));
  };

  const rowClick = (event: GridRowClickEvent) => {
    console.log(event);
    navigate("/manageAdmin/" + event.dataItem.userId);
  };

  // function convertRole(role: any) {
  //   switch (role) {
  //     case "adm_superAdmin":
  //       return "Super Admin";
  //     case "adm_contentCreator":
  //       return "Content Creator";
  //     case "adm_reviewer":
  //       return "Reviewer";
  //     case "adm_L1Admin":
  //       return "L1 Admin";
  //   }
  // }

  function convertRole(role: any) {
    switch (role) {
      case "adm_superAdmin":
        return intl.formatMessage({ id: "adminList.superAdmin" });
      case "adm_contentCreator":
        return intl.formatMessage({ id: "adminList.contentCreator" });
      case "adm_reviewer":
        return intl.formatMessage({ id: "adminList.reviewer" });
      case "adm_L1Admin":
        return intl.formatMessage({ id: "adminList.l1Admin" });
    }
  }
  

  React.useEffect(() => {
    let api = ApiServices.getInstance();
    api.makeRequest(`MikrosAdminUser`, "GET").then(async (data) => {
      if (data && data.errorMessage) {
        setErrorFlag(true);
        await errorInstance.updateErrorCode(data.errorMessage);
        return;
      }
      console.log("manage grid admin data", data);
      setDataGrid(data);
    });
  }, []);

  const createAdmin = () => {
    navigate("/manageAdmin/new");
  };
  return (
    <div>
      <div className="mt-4">
        {errorFlag && (
          <Dialog className="errorDialogue">
            <Alert
              description={intl.formatMessage({
                id: errorInstance.errorCode,
              })}
              buttonText={`${intl.formatMessage({
                id: "users.buttonText.Ok",
              })}`}
              icon={"errorShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgError",
              })}
              backgroundColor={"mk-red"}
              onClick={() => {
                setErrorFlag(false);
                navigate("/admin");
              }}
            />
          </Dialog>
        )}
        <div className="pb-4"></div>
        <div className="w-full flex justify-end items-center mt-[-2.25rem] right-12 top-20">
          <Button
            className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
           hover:text-black focus:outline-none px-4 py-2"
            onClick={createAdmin}
          >
            <FormattedMessage id="createAdmin.CreateAdmin" /> +
          </Button>
        </div>
        <div className="pb-4"></div>

        <Grid
          style={{ border: 0 }}
          rowHeight={48}
          data={dataGrid.slice(page.skip, page.skip + page.take)}
          skip={page.skip}
          take={page.take}
          total={dataGrid.length}
          className="cursor-pointer custom-grid"
          pageable={{
            buttonCount: 4,
            pageSizes: [5, 10, 15,intl.formatMessage({
              id: "adminList.gridAdminAll",
            })],
            pageSizeValue: pageSizeValue,
          }}
          onPageChange={pageChange}
          onRowClick={rowClick}
        >
          <GridColumn
            field="fname"
            title={`${intl.formatMessage({
              id: "searchUser.firstName",
            })}`}
            cell={(props) => <td>{props.dataItem.fname}</td>}
          />
          <GridColumn
            field="lname"
            title={`${intl.formatMessage({
              id: "searchUser.lastName",
            })}`}
            cell={(props) => <td>{props.dataItem.lname}</td>}
          />
          <GridColumn
            field="phNo"
            title={`${intl.formatMessage({
              id: "searchUser.mobileNumber",
            })}`}
            cell={(props) => <td>{props.dataItem.phNo}</td>}
          />
          <GridColumn
            field="email"
            title={`${intl.formatMessage({
              id: "searchCustomer.EmailId",
            })}`}
            cell={(props) => <td>{props.dataItem.email}</td>}
          />
          <GridColumn
            field="status"
            title={`${intl.formatMessage({
              id: "searchCustomer.CustomerGrid.Status",
            })}`}
            cell={(props) => <td>{props.dataItem.status}</td>}
          />
          <GridColumn
            field="role"
            title={`${intl.formatMessage({
              id: "createAdmin.Access",
            })}`}
            cell={(props) => <td>{convertRole(props?.dataItem?.role)}</td>}
          />
        </Grid>
        <div className="pb-[10%]"></div>
      </div>
    </div>
  );
}
